import React from "react";
import FilterBar from "./FilterBar";
export default function CourseFilterBar() {
	const courseFilterButtons = [
		{ name: "All", link: "/education/courses" },

		// { name: "Basics", link: "/education/courses/basic" },
		// { name: "Advanced", link: "/education/courses/advanced" },
		{ name: "CPE Core", link: "/education/courses/cpe-core" },
		{ name: "CPE Elective", link: "/education/courses/cpe-elective" },
		{ name: "Masters", link: "/education/courses/masters" },
		{ name: "Online", link: "/education/courses/online" },
		{ name: "Hybrid Online", link: "/education/courses/hybrid-online" },
		{ name: "In-Person", link: "/education/courses/in-person" },
	];

	return <FilterBar filterButtons={courseFilterButtons} hideAssessment={false} withProductSearch={true} />;
}
